import React from "react";

const Hero = () => (
  <section className="hero-banner">
    <div className="container">
      <div className="hero-caption">
        <div className="main-caption">
          Education and Lifestyle Platform committed to helping African
          immigrants actualize their dreams of studying, working and ultimately
          living in the US legally
        </div>
      </div>
      <div className="hero-image">
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/usa-flag.png`}
          alt=""
        />
      </div>
    </div>
  </section>
);

export default Hero;
